// The admin panel lives on its own host (`admin.localhost:3000` in dev,
// `admin.<domain>` deployed) — same Rails app, same bundle; the hostname's
// FIRST label decides which route tree the router builds. Mirrors the routes.rb
// constraint (⚠ not `subdomain:` — that parses two-label hosts as subdomain "").
export function isAdminHost(): boolean {
  return window.location.hostname.split('.')[0] === 'admin'
}

// The admin origin, derived from the current (tenant) host — keeps the port.
// admin. is a SIBLING label of the tenant's, not a child: a leading www. or
// app. (the prod tenant host, see doc/FEATURE_ADMIN_PANEL.md) is REPLACED,
// not prefixed — admin.app.domain.com is nobody's DNS record.
export function adminOrigin(): string {
  const { protocol, host } = window.location
  return `${protocol}//admin.${host.replace(/^(www|app)\./, '')}`
}
